<script>
	import FriendRow from './FriendRow.svelte';
	
	export let friends;
</script>

<h3>Who else is here</h3>
{#each friends as friend, i}
	<FriendRow
		{friend}
		type="friend"
	/>
{:else}
	<p>Go add some friends!  They'll show up here</p>
{/each}
